import React from 'react';
import NoteLists from 'components/NoteLists/NoteLists';
import { showAlert, useAppContext, usePatient } from '../../context/appContext';
import { HTTPError, Note, Patient } from '../../types/types';

function Notes() {
  const [{ user, patients }, dispatch] = useAppContext();
  const { patient } = usePatient();

  const handleSyncAddedNote = (newNote: Note) => {
    const updatePatients = patients.map(fndPatient => ({
      ...fndPatient,
      ...(fndPatient.id === patient.id && {
        patientDetails: {
          ...fndPatient.patientDetails,
          extendedNotes: [newNote, ...(fndPatient?.patientDetails?.extendedNotes || [])],
        },
      }),
    })) satisfies Patient[];

    dispatch({ type: 'SET_ASSIGNED_PATIENTS', payload: updatePatients });
  };

  if (!user) return null;

  return (
    <div className="flex flex-col pt-0 pb-3 tablet:pt-5 tablet:pb-1">
      <NoteLists
        user={user}
        patient={patient}
        onSyncAddedNote={handleSyncAddedNote}
        onShowAlert={(error: HTTPError) => {
          showAlert(dispatch, {
            show: true,
            type: 'ERROR',
            message: error.message,
          });
        }}
      />
    </div>
  );
}

export default Notes;
